import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-widget-data',
  imports: [NgClass],
  templateUrl: './no-widget-data.component.html',
  standalone: true,
  styleUrl: './no-widget-data.component.scss'
})
export class NoWidgetDataComponent {

  private defaultSVG = 'svg/no-widget-data.svg';

  @Input() class: string = '';
  @Input() svgSrc?: string =  this.defaultSVG;

  protected onIconError(event: Event): void {
    (event.target as HTMLImageElement).src = this.defaultSVG;
  }
}
